import {
    SNACKBAR_MSG
} from '../types';

const initialState = {
    snackmsg: null
}

export default function(state = initialState, action) {
    switch(action.type) {        
        case SNACKBAR_MSG:
            return {
                ...state,
                snackmsg: action.payload
            }
        default:
            return state;
    }
}
